import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import { store } from 'react-notifications-component';
import NumberFormat from 'react-number-format';

import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import ConfirmPayment from './confirm'

import Backend from '../../Backend';
import Connection from '../../Calls';

import SearchImage from '../../Images/search.svg';
import Flecha from '../../Images/flecha.svg'
import Info from '../../Images/Copia de info.svg'

import './index.css'
import Receipt from './receipt';
import Transactions from './transactions';
import es from '../../translate/es';
import en from '../../translate/en';

var date = new Date();

class ServicesIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      search:'',
      wallets:[],
      service:'',
      reference:'',
      amount:'',
      label_service: this.props.lan === 'es' ? es.services.referenceNum : en.services.reference,
      selectedCoin:{},
      services:[
        'AT&T',
        'Telmex',
        'Netflix'
      ],
      filtered:[
        'AT&T',
        'Telmex',
        'Netflix'
      ],
      servicesList:[],
      availableCoinsArray:[],
      viewState:'pago',
      showServiceHintFullScreen: false,
    }
  }

  componentDidMount() {
    this.loadData()
  }

  loadData(){
    const self = this
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.general_get('get_wallets_settings',response.payload.r01,response=>{
        // this.setState({ecommerce:true, ...response.payload})
      })

      Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), '', 1, 100000, response.payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({wallets: response.payload});
        } else {
          this.addNotification('Error!',response.status.description,'danger')
        }
        self.setState({showload:false})
      });

      Backend.Check2FA(localStorage.getItem('email'), localStorage.getItem('token'),response.payload.r01, response =>{
        if(response.status.code === "0"){
          if(response.payload.status === "enabled"){
            this.setState({TWOfa:true})
          }else{
            this.setState({TWOfa:false})
          }
        }
      })

      Backend.availableCoins( response => {
        this.setState({
          availableCoinsArray: response.payload
        })
      })

      Backend.get_services_list(response.payload.r01, response => {
        if(response.status.code === "0"){
          const {list_services} = response.payload
          list_services.map((service) => {
            if (service.name === "CFE") {
              service.category = "luz";
            } else if (service.name.includes("SADM (Monterrey)")) {
              service.category = "agua";
            } else if (service.name.includes("Telmex")) {
              service.category = "teléfono";
            } else if (service.name.includes("Dish")) {
              service.category = "teléfono";
            } else if (service.name.includes("IZZI Telecom")) {
              service.category = "teléfono";
            } else if (service.name.includes("Naturgy")) {
              service.category = "gas";
            } else if (service.name.includes("Totalplay")) {
              service.category = "teléfono";
            } else if (service.name.includes("AMD (Durango, Dgo.)")) {
              service.category = "agua";
            } else if (service.name.includes("COMAPA (Nuevo Laredo, Tam.)")) {
              service.category = "agua";
            } else if (service.name.includes("JUMAPA (Celaya, Gto.)")) {
              service.category = "agua";
            } else if (service.name.includes("JUMAPAM (Mazatlan)")) {
              service.category = "agua";
            } else if (service.name.includes("Megacable")) {
              service.category = "teléfono";
            } else if (service.name.includes("Movistar Postpago")) {
              service.category = "teléfono";
            } else if (service.name.includes("SACMEX (CDMX)")) {
              service.category = "agua";
            } else if (service.name.includes("SIAPA (Guadalajara)")) {
              service.category = "agua";
            } else if (service.name.includes("SKY - VeTv")) {
              service.category = "teléfono";
            } else if (service.name.includes("Telcel")) {
              service.category = "teléfono";
            }
          });
          this.setState({servicesList: list_services});
        }
     })

    })
  }

  addNotification(title,message,type){
    store.addNotification({
      title,
      message,
      type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 1800,
        onScreen: true
      }
    });
  }

  renderList(){
    const {search} = this.state;

    if(this.state.servicesList.length>0){
      let newFiltered = [];
      const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      };
    
      const searchTermWithoutAccents = removeAccents(search.toLowerCase());
    
      newFiltered = this.state.servicesList.filter((service) => {
        const categoryWithoutAccents = removeAccents(service.category.toLowerCase());
        return categoryWithoutAccents.includes(searchTermWithoutAccents);
      });
    
      if (newFiltered.length === 0) {
        newFiltered = this.state.servicesList.filter((service) => {
          const nameWithoutAccents = removeAccents(service.name.toLowerCase());
          return nameWithoutAccents.includes(searchTermWithoutAccents);
        });
      }

      return newFiltered.map((item)=>{
        return(
          <button onClick={()=>{this.setState({service:item, label_service: item?.identifier})}} className={this.state.service?.id == item.id ?'services_button active' :'services_button' }>
            {
              (item.logo == 'NO LOGO')
              ? item.name
              : <Image src={'data:image/svg+xml;base64,'+item.logo} style={{ height:45 }} />
            }
          </button>
        )
      })
    }
  }

  searchFunction(){
    let { services, search } = this.state
    this.setState({
      filtered: services.filter( i => i.toLowerCase().indexOf(search.toLowerCase()) != -1 )
    })
  }

  handleInput(e){
    const self = this;
    if(this.state.timeout) clearTimeout(this.state.timeout)
    this.setState({
      search:e.target.value,
      timeout:setTimeout(()=>{
        self.searchFunction()
      }, 500)
    })
  }

  renderListWallets() {
    const self = this;
    var wallets = [];
    if(self.state.selectedCoin.symbol)
    self.state.wallets.filter(w => w.coin == self.state.selectedCoin.symbol).forEach(function (item) {
      wallets.push(
        <Dropdown.Item onClick={()=>self.selectWallet(item)} as="button">
          <Image src={require("../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {item.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(item.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{item.coin}</label>
        </Dropdown.Item>
      );
    });
    return wallets;
  }

  renderListCoin() {
    const self = this;
    var coins = [];
    if(self.state?.availableCoinsArray.length>0)
    self.state.availableCoinsArray.forEach(function (item) {
      coins.push(
        <Dropdown.Item onClick={()=>self.setState({selectedCoin:item})} as="button">
          <Image src={require("../../CryptoIcons/" + item.symbol + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {item.name}
        </Dropdown.Item>
      );
    });
    return coins;
  }

  selectWallet(wallet){
    const self = this;

    this.state.availableCoinsArray.forEach((item, i) => {
      if(item.symbol == wallet.coin){
        this.setState({
          usdPrice: item.usd_price
        })
      }
    });
    this.setState({ selectedWallet: wallet, wallet_alias:wallet.alias, coin:wallet.coin })
  }

  showConfirm(){
    let {  amount, selectedCoin } = this.state
    let price = selectedCoin.usd_price

    this.setState({
      crypto_price:price,
      confirm:true,
      viewState:'confirm'
    })
  }

  renderContent(){
    let { services, ecomm } = this.props.traductions
    let { service, reference, amount, selectedWallet, selectedCoin } = this.state
    return(
      <Container className="services_container" style={{ paddingLeft: 10, paddingRight: 10 }}>
        <div className='flex space-between bmargin10'>
          <p className='dark-text medium-dms text-25'>{services.title}</p>
          <p className='dark-text medium-dms text-25'  style={{ cursor:'pointer', fontSize:15, color:'#FF9C2A'}} onClick={()=>this.setState({viewState:'transactions'})}>{services.seeTrans}</p>
        </div>

        <div className='container-transactions'>
          <div className='flex wrap w100 justify-start'>
            <span className='blue-text medium-dms' style={{marginRight:30}}>{services.step1}</span>
            <div className='flex1 responsive-minWidth' >
              <Form.Control
                style={{ height: 40 }}
                className="input-services"
                type="text"
                placeholder={ecomm.search}
                value={this.state.search}
                onChange={(e)=>this.handleInput(e)}
                />
            </div>
          </div>
          <div className='flex-row-container'>
            <div className='scroll_btn left' onClick={()=>{window.document.getElementById('services-list-container').scrollLeft -= 280}}>
              <Image src={Flecha} style={{ marginRight: 5, width: 10, transform:'scaleX(-1)' }} />
            </div>
            <div style={{flex:1, overflow:'hidden'}}>
              <div id='services-list-container'>
                <div className='service-inner-container'>
                  {this.renderList()}
                </div>
              </div>
            </div>
            <div className='scroll_btn right' onClick={()=>{window.document.getElementById('services-list-container').scrollLeft += 280}}>
              <Image src={Flecha} style={{ marginLeft: 5, width: 10 }} />
            </div>
          </div>
          <span style={{fontSize: 14, color:'#FF9C2A'}}>{services.legend}</span>

          <div className={(service)?'services-step active':'services-step'}>

            <p className='blue-text medium-dms'>{services.step2}</p>
            <Row>
              <Col>
                <div style={{display:'flex', alignItems:'center'}}>
                  <p className="dark-text normal-dms font-17 bmargin0">{this.state.label_service}</p>
                  <button className='services_hover_button' onMouseEnter={()=>this.setState({showImage:service})} onMouseLeave={()=>this.setState({showImage:false})} style={{position:'relative'}} onClick={() => this.setState({showServiceHintFullScreen: true})} disabled={!service.instructions}>
                    <Image src={Info} width={15} height={15} style={{marginLeft:8}}/>
                  </button>
                  <div className='services_hover_image' style={{display:(this.state.showImage)?'block':'none'}}>
                    <Image src={service.instructions || ''} height={400} />
                  </div>
                </div>
                {/* Full screen service instructions */}
                <Modal
                  className="modal-signup-resend-email"
                  centered
                  aria-labelledby="contained-modal-title-vcenter"
                  show={this.state.showServiceHintFullScreen}
                  onHide={() => {this.setState({showServiceHintFullScreen: false })}}
                >
                  <Modal.Body>
                    <div className='services_fullscreen_image'>
                      <Image src={service.instructions || ''} style={{height: 'calc(100vh - 100px)'}} />
                    </div>
                  </Modal.Body>
                </Modal>

                <Form.Control
                  type="number"
                  placeholder={services.referenceNum}
                  className="input-services"
                  value={this.state.reference}
                  disabled={!service}
                  onChange={(reference) => { this.setState({ reference: reference.target.value }) }}
                />
              </Col>

              <Col>
                <p className="dark-text normal-dms font-17 bmargin0">{services.amount}:</p>
                <NumberFormat
                  type="text"
                  placeholder={services.amount}
                  className="input-services"
                  value={this.state.amount}
                  disabled={!service}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={'$'}
                  onValueChange={({formattedValue, value}) => { this.setState({ amount: value, mxn_price: formattedValue}) }}
                  suffix=' MXN'
                />
              </Col>
              {/*<Col>
                <p className='text-available-modal'>Available: {this.state.fromWallet.balance} {this.state.fromWallet.coin}</p>
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">Amount</Form.Label>
                  <Col sm="10" className="virtual_exchange_dropdown">
                    <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                      {
                        (this.state.selectedCurrency == 'usd')
                        ? <NumberFormat className='btc-format-input' placeholder="USD Amount" decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                        : <NumberFormat className='btc-format-input' placeholder={this.state.fromWallet.coin.toUpperCase() + ' Amount'} decimalScale={8} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                      }
                      <Button className={(this.state.selectedCurrency === this.state.fromWallet.coin) ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: this.state.fromWallet.coin }) }}>{this.state.fromWallet.coin.toUpperCase()}</Button>
                      <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                    </div>
                    <div className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error"}>
                      <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"} style={{marginBottom: 2}}>You will transfer {Number(this.calculateCrypto()* intenalFee).toFixed(8)} {this.state.fromWallet.coin} ({Number(this.props.planInfo.transfer_internal).toFixed(0)}% fee)</p>
                      <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>Approximately {this.calculateUSD()} usd</p>
                    </div>
                  </Col>
                </Form.Group>
              </Col>*/}
            </Row>

          </div>

          <div className={(reference && amount)?'services-step active':'services-step'}>

            <p className='blue-text medium-dms'>{services.step3}</p>
            <Row>
              <Col md={6} className='virtual_exchange_dropdown'>
                <Form.Label className="dark-text normal-dms font-17 bmargin0"> {this.props.traductions.services.coin}:</Form.Label>
                <Dropdown title={(selectedCoin)?selectedCoin.name:this.props.traductions.wallets.Index.modalTransfers.S_Wallets}>
                  <Dropdown.Toggle id="dropdown-custom-1" disabled={!reference || !amount}>
                    {
                      (selectedCoin.name)
                      ?
                      <>
                        <Image src={require("../../CryptoIcons/" + selectedCoin.symbol + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                        {selectedCoin.name}
                      </>
                      :this.props.traductions.services.coin
                    }
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.renderListCoin()}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col md={6} className='virtual_exchange_dropdown'>
                <Form.Label className="dark-text normal-dms font-17 bmargin0"> {this.props.traductions.wallets.Index.modalTransfers.L_FromWallets}:</Form.Label>
                <Dropdown title={(selectedWallet)?selectedWallet.alias:this.props.traductions.wallets.Index.modalTransfers.S_Wallets}>
                  <Dropdown.Toggle id="dropdown-custom-1" disabled={!reference || !amount}>
                    {
                      (selectedWallet)
                      ?
                      <>
                        <Image src={require("../../CryptoIcons/" + selectedWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                        {selectedWallet.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(selectedWallet.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{selectedWallet.coin}</label>
                      </>
                      :this.props.traductions.wallets.Index.modalTransfers.S_Wallets
                    }
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.renderListWallets()}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              {/*<Col>
                <p className="dark-text normal-dms font-17 bmargin0">{services.amount}:</p>
                <Form.Control
                  type="number"
                  placeholder={services.amount}
                  className="input-services"
                  value={this.state.codeValidate}
                  disabled={!reference && amount}
                  onChange={(codeValidate) => { this.setState({ codeValidate: codeValidate.target.value }) }}
                />
              </Col>*/}
            </Row>

          </div>

          <div>
            <button
              disabled={!service || !reference || !amount || !selectedWallet}
              className={(!service || !reference || !amount || !selectedWallet)?'services_continue_button disabled':'services_continue_button'}
              onClick={()=>this.showConfirm()}
              >
              {services.continue}
            </button>
          </div>

        </div>
      </Container>
    )
  }

  resetData () {
    this.setState({confirm:false, viewState:'pago'})
    this.setState ({
      search:'',
      service:'',
      reference:'',
      amount:'',
      selectedCoin:{},
      viewState:'pago',
      selectedWallet:null,
      wallet_alias:null,
      coin:null
    })
  }

  render() {
    return (
      <div>
        <NavbarComponent data={this.props} selected="services" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          {
            this.state.viewState=='pago'
              ?this.renderContent()
              :this.state.viewState=='confirm'
                ?<ConfirmPayment  {...this.props} {...this.state} goBack={()=>this.setState({confirm:false, viewState:'pago'})} goReceipt={(valueCrypto)=>{this.setState({viewState:'receipt',valueCrypto:valueCrypto})}}/>
                :this.state.viewState=='receipt'
                  ?<Receipt {...this.props} {...this.state} goBack={()=>{this.resetData()}} />
                  :<Transactions {...this.props} {...this.state} goBack={()=>this.setState({confirm:false, viewState:'pago'})} />
          }
        </div>

      </div>
    );
  }
} export default ServicesIndex;
